function setHeaderPromoHeight() {
  if ($('.header-promo').length) {
    let height = $('.header-promo').outerHeight();
    $('body').css('--header-promo-height', height + 'px');
  }

  let header_height = $('.header').outerHeight();
  $('body').css('--header-height', header_height + 'px');
}
$(window).on('resize', function () {
  setHeaderPromoHeight();
});

/**** Main Logic to  add event handler and other minute items ****/
$(document).ready(function () {
  setHeaderPromoHeight();
  /*** Focus on the input field inside the form on click of search button ****/
  $(".search_header").click(function () {
    $(this).closest("form").find("#input_search_header").focus();
    $("#gl-d-searchbox-input").attr("required", "required");
  });
});

$(".faq-circle").click(function () {
  $(this).toggleClass("active");
  var faqContent = $(this).parent().next(".faq-content");
  $(".faq-content").not(faqContent).slideUp();
  faqContent.slideToggle();
  $(".faq-circle").not(this).removeClass("active");
});

$(".collection-banner.about-us").closest(".c_main").addClass("sectiong-top-head-padding");

// click on the first link
$(".wrapper-text-nav-tc a[href='#overview']").click(function () {
  $("html, body").animate({
      scrollTop: $("#overview").offset().top - $(".header").outerHeight(),
  }, 1000);
});

// click on the second link
$(".wrapper-text-nav-tc a[href='#product-use']").click(function () {
  $("html, body").animate({
      scrollTop: $("#product-use").offset().top - $(".header").outerHeight(),
  }, 1000);
});

// click on the third link
$(".wrapper-text-nav-tc a[href='#disclaimer']").click(function () {
  $("html, body").animate({
      scrollTop: $("#disclaimer").offset().top - $(".header").outerHeight(),
  }, 1000);
});

/*** end min cart template update ***/
$(".text-info-bar-mainn").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  adaptiveHeight: true,
  autoplay: true,
  autoplaySpeed: 3000,
  vertical: true,
  verticalSwiping: true,
});

$(document).ready(function () {
  /*** Remove : Code for on click event listener on remove button ****/
  $(document).on("click", ".c_drawer-menu", function () {
    $(this).next(".c_drawer-rmv").toggle();
    $(this).toggleClass("c_drawer-menu-click");
  });
});

$("body:not(.kit-v2) .kit-pro-thumb:not(.pro-images)").slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 790,
      settings: {
        slidesToShow: 1.7,
        slidesToScroll: 1,
      },
    },
  ],
});

/* ==================== Kit New Landing Page JS ==================== */
/* Product image for mobile */
var slickSlider = $("body:not(.kit-v2) .pro-images");
slickSlider.slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  adaptiveHeight: true,
  asNavFor: '.pro-thumb-images',
  responsive: [
    {
      breakpoint: 790,
      settings: {
        slidesToShow: 1.6,
        slidesToScroll: 1,
      },
    },
  ],
});

$('.kit-product-v3 [data-fancybox="gallery2"], .kit-product-v3 [data-fancybox="mobile gallery"]').fancybox({
  backFocus: false,
  loop: true,
  hash: false,
  touch: true,
  mobile: {
    clickSlide: "close",
    clickOutside: "close",
  },
  clickSlide: "close",
  clickOutside: "close",
  video: {
    autoStart: false,
  },
  beforeClose: function (instance, slide) {
    let video = slide.$content.find("video").get(0);
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  },
  afterClose: function(instance, current) {
    let lastIndex = instance ? instance.currIndex : 0;
    $('.thumb-item[data-slick-index="'+lastIndex+'"]').click();
  }
});

$('.pro-thumb-images').slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  infinite: false,
  asNavFor: '.pro-images',
  arrows: true,
  prevArrow: '<button type="button" class="custom-arrow arrow-prev"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M1.5 11.9813L2.83125 13.3125L9 7.14375L15.1688 13.3125L16.5 11.9812L9 4.48125L1.5 11.9813Z" fill="#522C6B"/></svg></button>',
  nextArrow: '<button type="button" class="custom-arrow arrow-next"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M1.5 6.01875L2.83125 4.6875L9 10.8563L15.1688 4.6875L16.5 6.01875L9 13.5188L1.5 6.01875Z" fill="#522C6B"/></svg></button>',
  vertical: true,
  verticalSwiping: true,
  focusOnSelect: true,
  responsive: [
      {
        breakpoint: 790,
        settings: {
          vertical: false,
          verticalSwiping: false,
          arrows: false,
        }
      }
    ]
});
if($('.image-with-text-slider').length > 0) {
  $('.image-with-text-slider').slick({
    autoplay: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: $('.desktop-custom-slick-prev'),
    nextArrow: $('.desktop-custom-slick-next'),
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 790,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow: $('.custom-arrow-wrapper .custom-slick-prev'),
          nextArrow: $('.custom-slick-next')
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: $('.custom-slick-prev'),
          nextArrow: $('.custom-slick-next')
        }
      }
    ]
  });
}
if ($('.video-container .video-wrapper').length > 0) {
  $('.video-container .video-wrapper .custom-play-button').on('click', function () {
    console.log("Video button click event");
    const $videoContainer = $(this).closest('.video-container');
    if ($videoContainer.hasClass('slick-center')) {
      console.log("Check the slick-center Class");
      $videoContainer.find('.video-wrapper').addClass('active');
      const $video = $videoContainer.find('video');
      if ($video.length > 0 && $video.prop('paused')) {
        $video.prop('muted', false);
        $video.get(0).play();
      }
    }
  });
  
}

if ($(".comparison-section .tab-item").length > 0 ) {
  $(".comparison-section .tab-item").on("click", function () {
    $(".comparison-section .tab-item").removeClass("active");
    $(".comparison-section .tab-content").removeClass("active");
  
    $(this).addClass("active");
    $("#tab-" + $(this).data("tab")).addClass("active");
  });
}
$(".custom-review-product-summary").on("click", function () {
  let targetSelector = $(this).attr("data-scroll-target");
  let targetElement = $(targetSelector);

  if (targetElement.length) {
    $("html, body").animate({
      scrollTop: targetElement.offset().top
    }, 800);
  }
});

document.querySelectorAll(".tooltip-wrapper").forEach((icon) => {
  let tooltip = icon.querySelector(".tooltip-box");
  let tooltipIcon = icon.querySelector(".tooltip-icon");
  let closeBtn = icon.querySelector(".close-tooltip");

  if (!tooltip) return; // Skip if no tooltip exists

  icon.addEventListener("mouseenter", function () {
    let rect = tooltipIcon.getBoundingClientRect();
    let tooltipRect = tooltip.getBoundingClientRect();

    tooltip.style.position = "fixed";
    tooltip.style.left = `${Math.min(rect.left + rect.width / 2)}px`;
    tooltip.style.top = `${Math.max(rect.top - tooltipRect.height - 5, 10)}px`;
    tooltip.style.visibility = "visible";
    tooltip.style.opacity = "1";
  });

  icon.addEventListener("mouseleave", hideTooltip);
  if (closeBtn) closeBtn.addEventListener("mouseenter", hideTooltip);

  function hideTooltip() {
    // alert("Hidden Tooltip:::");
    tooltip.style.visibility = "hidden";
    tooltip.style.opacity = "0";
    tooltip.style.left = "auto";
    tooltip.style.top = "auto";
  }
});
/* ==================== End Kit New Landing Page JS ==================== */

/*Scroll Up/Down add class */
var lastScrollTop = 0;
$(window).scroll(function (event) {
  var st = $(this).scrollTop();
  if (st > lastScrollTop) {
    $("body").addClass("scrolling_down");
    $("body").removeClass("scrolling_up");
  } else {
    $("body").addClass("scrolling_up");
    $("body").removeClass("scrolling_down");
  }
  lastScrollTop = st;
});

$(window).scroll(function (event) {
  var scroll = $(window).scrollTop();
  const el = $("._custom-color-main");
  const offsetTopEl = el?.offset()?.top || 0;
  $("#sticky-container").toggleClass("stickhere", scroll >= offsetTopEl + 500);

  const el1 = $("#csWrapperCart");
  const offsetTopEl1 = el1?.offset()?.top || 0;
  $("#sticky-containers").toggleClass("stickhere", scroll >= offsetTopEl1);
});

function sticky_relocate() {
  var window_top = $(window).scrollTop();
  var footer_top = $("#c-footer").offset().top;
  var div_height = $("#sticky-container").height() + 800;
  if (window_top + div_height > footer_top) {
    $("#sticky-container").addClass("u-hidden");
  } else {
    $("#sticky-container").removeClass("u-hidden");
  }
  var div_heights = $("#sticky-containers").height() + 800;
  if (window_top + div_heights > footer_top) {
    $("#sticky-containers").addClass("u-hidden");
  } else {
    $("#sticky-containers").removeClass("u-hidden");
  }
}

$(function () {
  $(window).scroll(sticky_relocate);
  sticky_relocate();
});

// $(document).ready(function () {
//   if ($(".custom-aattcc[disabled]").length > 0) {
//     setTimeout(function () {
//       $(".custom-aattcc2").val("Add to Cart");
//     }, 400);
//   }
// });

/* Script added by speed optimization team */
var script_loaded = !1;
function loadJSscripts() {
  script_loaded ||
    (void 0 !== observer && observer.disconnect(),
    void 0 !== window.yett && window.yett.unblock(),
    (script_loaded = !0),
    document.querySelectorAll("iframe[data-src], script[data-src], img[data-src]").forEach((e) => {
        (datasrc = e.dataset.src), null != datasrc && (e.src = datasrc);
    }),
    document.querySelectorAll("link[data-href]").forEach((e) => {
      (datahref = e.dataset.href), null != datahref && (e.href = datahref);
    }),
    document.querySelectorAll("script[type='text/lazyload']").forEach((e) => {
      var t = document.createElement("script");
      for (a = 0; a < e.attributes.length; a++) {
        var r = e.attributes[a];
        t.setAttribute(r.name, r.value);
      }
      (t.type = "text/javascript"),
        (t.innerHTML = e.innerHTML),
        e.parentNode.insertBefore(t, e),
        e.parentNode.removeChild(e);
    }),
    document.dispatchEvent(new CustomEvent("asyncLazyLoad")));
}
var activityEvents = [
  "mousedown",
  "mousemove",
  "keydown",
  "scroll",
  "touchstart",
  "click",
  "keypress",
  "touchmove",
];
activityEvents.forEach(function (e) {
  window.addEventListener(e, loadJSscripts, !1);
});

// kits megamenu hide and show js
const hoverable = document.querySelector('.menu-name-kits');
const targetDiv = document.querySelector('.kits-megamenu');

hoverable.addEventListener('mouseenter', function() {
  targetDiv.classList.add("active");
});

hoverable.addEventListener('mouseleave', function() {
  targetDiv.classList.remove("active");
});